import React, { useEffect, useState } from 'react'
import './styles.scss'
import Stars from '../stars/stars.component'
// import SwiperCore, { Controller } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.scss'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'

import { data } from './data.js'

function Item(props) {
  return (
    <div className='item' onClick={() => props.onClick(props.id)}>
      <img
        src={props.image}
        className={`preview ${props.active ? 'active' : ''}`}
      />
      <h1>{props.name}</h1>
      <div className='rating'>
        {props.rating} <Stars rating={props.rating} />
      </div>
      {props.address}
    </div>
  )
}

function Highlights(props) {
  const [controlledSwiper, setControlledSwiper] = useState(null)
  const [map, setMap] = useState(null)
  const [active, setActive] = useState(null)
  const [activeMarker, setActiveMarker] = useState(null)
  const [activeSlide, setActiveSlide] = useState(0)

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: 'map',
      style:
        'https://api.maptiler.com/maps/topo/style.json?key=nu1rAHfpx6ICwiBr4BQr',
      center: props.coords,
      zoom: 10,
      interactive: false,
      maxZoom: 15
    })

    map.on('load', () => {
      for (const i in data) {
        // const defaultColor = '#378EBD';
        const colorMcdonalds = '#ffca00'
        const colorBurgerking = '#b20b36'
        const marker = new mapboxgl.Marker({
          color: data[i].brand === 'mcdonalds' ? colorMcdonalds : colorBurgerking
        })
          .setLngLat(data[i].position)
          .addTo(map)
        marker.getElement().addEventListener('click', () => {
          // Set active
          setActive(parseInt(i))

          // Swipe Swiper
          // controlledSwiper.swipeTo(i)
          setActiveSlide(i)
        })
        data[i].marker = marker
      }

      map.fitBounds(
        [
          [8.34, 47.15],
          [9.0, 47.71]
        ],
        { duration: 0 }
      )
    })
    setMap(map)
  }, [])

  useEffect(() => {
    if (active) {
      if (activeMarker) activeMarker.remove()

      const marker = new mapboxgl.Marker({ color: '#3b3c57' })
        .setLngLat(data[active].position)
        .addTo(map)

      setActiveMarker(marker)
    }
  }, [active])

  useEffect(() => {
    if (controlledSwiper) controlledSwiper.slideTo(activeSlide)
  }, [activeSlide])

  return (
    <div className='highlights'>
      <h3>{props.title}</h3>

      <Swiper
        onSwiper={setControlledSwiper}
        spaceBetween={10}
        slidesPerView='auto'
        centeredSlides
      >
        {data.map((e, i) => (
          <SwiperSlide key={i}>
            <Item
              rating={e.rating}
              onClick={e => {
                setActive(e)
                map.jumpTo({ center: data[e].position, zoom: 15 })
              }}
              name={e.name}
              address={e.address}
              image={e.image}
              id={i}
              active={i === active}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div id='map' />
    </div>
  )
}

export default Highlights
